export interface Category {
  key: string;
  icon: string;
  color?: string;
  banner?: string;
  id: string;
  iconSource?: string;
  minUsers?: number;
  maxUsers?: number;
  reviewableAttributes?: string[];
}


export function createCategory(params: Partial<Category>) {
  return {
    ...params
  } as Category;
}
